import axios from 'axios'
import history from '../history'

const http = axios.create({
    baseURL: process.env.REACT_APP_API_BASEURL
})
const HEADERS = {
    'Content-Type': 'application/json'
};
const qs = require('qs')

export async function postLoadReset(token, dispatch) {
    const tokenEncoded = qs.stringify({
        token: token
    })
    dispatch({ type: 'OPEN_LOADING' })
    await http.post(`/account/reset?${tokenEncoded}`,
        {
        },
        {
            headers: HEADERS
        }).then(response => {
            successPostLoadReset(response, dispatch);
        }).catch(erro => {
            erroPostLoadReset(erro.response, dispatch);
        })
    dispatch({ type: 'CLOSE_LOADING' })
};

function successPostLoadReset(response, dispatch) {
    if (response.status === 200) {
        dispatch({
            type: 'SET_TOKEN_RESETSENHA',
            token: response.data.token
        })
    }
}

function erroPostLoadReset(erro, dispatch) {
    if (erro !== undefined && erro.status === 400) {
        dispatch({
            type: 'OPEN_ALERT_DIALOG',
            title: 'Recuperação de senha',
            description: 'Link expirado, solicite um novo link pelo site'
        })

        history.push('/login')
    }
}

export async function postResetSenha(token, senha, dispatch) {

    dispatch({ type: 'OPEN_LOADING' })
    await http.post(`/account/reset?token=${token}`,
        {
            "password": senha
        },
        {
            headers: HEADERS
        }).then(response => {
            successPostResetSenha(response, dispatch);
        }).catch(erro => {
            erroPostResetSenha(erro.response, dispatch);
        })
    dispatch({ type: 'CLOSE_LOADING' })
};

function successPostResetSenha(response, dispatch) {
    if (response.status === 200) {
        dispatch({
            type: 'OPEN_ALERT_DIALOG',
            title: 'Recuperação de senha',
            description: 'Senha alterada com sucesso'
        })
        history.push('/login')
    }
}

function erroPostResetSenha(erro, dispatch) {
    if (erro !== undefined && erro.status === 400) {
        dispatch({
            type: 'OPEN_ALERT_DIALOG',
            title: 'Recuperação de senha',
            description: 'Link expirado, solicite um novo link pelo site'
        })

        history.push('/login')
    }
}